<template>
  <div v-if="user !== null && user !== undefined">
    <!-- <v-card 
      height="2000px"
      flat>
      <div class="headline text-xs-center pa-5">
        Active: {{ bottomNavActive }}
      </div> 
    </v-card>
     -->
    <!-- Container um Content nicht von BootmNav zu verdecken; Höhe: = BottomNav-höhe -->
    <v-container 
      fluid 
      style="z-index: 0; height: 48px;"></v-container>

    <v-btn
      v-if="user"
      id="addEvent"
      value="plusplus"
      fab
      dark
      to="/add"
      @click="setCreateActivity(true)">
      <v-icon small>
        fas fa-plus
      </v-icon>
    </v-btn>

    


    <v-bottom-nav
      
      :value="isMobile"
      height="48px"
      :active.sync="bottomNavActive"
      color="white"
      fixed>
      <v-btn 
        v-for="item in navItems"

        :key="item.title"

        :color="item.color"
        :value="item.title"
        :disabled="item.disabled"
        :to="item.path"
        flat
        @click.prevent="toTop">
        <!-- @click.stop="toTop" -->
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>

      <!-- Profile -->
      <v-btn 
        v-if="user"
        key="Profile"
        value="Profile"
        to="/profile"
        @click.prevent="toTop">
        <v-avatar
          size="24px"

          color="grey lighten-4">
          <v-img 

            :src="user.profileImg" 
            alt="avatar"></v-img>
        </v-avatar>
      </v-btn>
    </v-bottom-nav>
  </div>
</template>


<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      bottomNavActive: '',
      fab: false,
      transition: 'slide-y-reverse-transition',
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
      isMobile: state => state.isMobile,
      breakPointMobile: state => state.breakPointMobile,
      navItems: state => state.navigation.responsive.navItems
    })
  },
  methods: {
    ...mapMutations([
      'setCreateActivity'
    ]),
    toTop() {
      this.$vuetify.goTo(0, {
        duration: 1000,
        offset: 0,
        easing: 'easeInOutQuint'
      })
    }
   
  }
}
</script>

<style lang="scss" scoped>
.v-bottom-nav .v-btn {
  min-width: 10px;
  padding: 0;
  margin: 0;
}

#addEvent {
  position: fixed;
  bottom: 10px;
  left: 50%;
  margin: 0;
  padding: 0;
  transform: translate(-50%, 0);
  z-index: 5;
  border: 3px solid white;
  background-image: linear-gradient(330deg, #d81b60, #eeff41);
}

</style>
